import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Film, Sparkles } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

/**
 * Studio avatar — Impostazioni → «Studio avatar» (I-416, L-2762), solo i ruoli creatore (`administrator` e, su staging, `avatar_creator_collaudo`).
 *
 * Per ora e' la porta della creazione che c'e' gia': la stessa UI di `/avatars/new` e dell'editor guidato,
 * raggiunta da qui. La pubblicazione nel negozio arriva in un lotto dopo e NON e' qui.
 *
 * Il ruolo e il flag stanno nella ROTTA (`router.tsx`: flag + `<CreatoreGate>`), non in questo
 * componente: una pagina che si controlla da sola si dimentica di essere montata altrove.
 */
export function StudioAvatar() {
  const { t } = useTranslation('avatars');

  return (
    <div className="flex flex-col gap-4 px-4 pb-6 pt-5">
      {/* I-318, ADR-0190 §1: titolo di sezione fuori dalla vista, `sr-only`; la chiave resta in uso. */}
      <header className="sr-only">
        <h1>{t('studio.title')}</h1>
        <p>{t('studio.subtitle')}</p>
      </header>

      <section className="flex flex-col gap-2">
        <StudioRow to="/avatars/new" icon={Sparkles} title={t('list.create')} subtitle={t('studio.create_hint')} />
        <StudioRow to="/avatars/editor" icon={Film} title={t('list.editorTitle')} subtitle={t('list.editorSubtitle')} />
      </section>
    </div>
  );
}

function StudioRow({
  to,
  icon: Icon,
  title,
  subtitle,
}: {
  to: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  subtitle: string;
}) {
  return (
    <Link
      to={to}
      className="card-edge flex items-center gap-3 rounded-xl bg-bg-secondary p-3 transition-opacity active:opacity-80"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-bg-tertiary text-brand">
        <Icon className="h-4 w-4" />
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-semibold text-fg">{title}</span>
        <span className="truncate text-xs text-fg-muted">{subtitle}</span>
      </span>
      <ChevronRight aria-hidden className="h-5 w-5 shrink-0 text-fg-muted" />
    </Link>
  );
}
